/* eslint-disable no-empty-function */
import PropTypes from "prop-types";
import React from "react";

const CartHeader = ({
  classes,
  handleBackButton,
  handleCloseCartModal,
  itemCount,
  showBackButton,
  showCloseButton,
  title
}) => {
  const getItemCount = () => {
    if (!itemCount) return "";

    return ` (${itemCount})`;
  };

  return (
    <div className={`cart-bold-header py-2.5 px-4 w-full flex items-center ${classes}`}>
      {!showBackButton &&
      <div className="size-4" />}
      {showBackButton &&
      <div
        aria-description="Go Back to Cart"
        aria-role="button"
        className="size-4 cursor-pointer back-button bg-no-repeat bg-center bg-cover bg-icon-chevron-left"
        onClick={handleBackButton}
      />}
      <div className="title font-serif proportional-nums capitalize leading-none">
        {title}
        {getItemCount()}
      </div>
      {!showCloseButton &&
      <div className="size-4" />}
      {showCloseButton &&
      <div
        aria-description="Close the Cart"
        aria-role="button"
        className="size-4 cursor-pointer close-button bg-no-repeat bg-center bg-cover bg-icon-xmark"
        onClick={handleCloseCartModal}
      />}
    </div>
  );
};

CartHeader.propTypes = {
  "classes": PropTypes.string,
  "handleBackButton": PropTypes.func,
  "handleCloseCartModal": PropTypes.func,
  "itemCount": PropTypes.number,
  "showBackButton": PropTypes.bool,
  "showCloseButton": PropTypes.bool,
  "title": PropTypes.string
};

CartHeader.defaultProps = {
  "classes": "center",
  "handleBackButton": () => {},
  "handleCloseCartModal": () => {},
  "itemCount": null,
  "showBackButton": false,
  "showCloseButton": false,
  "title": "my cart"
};

export default CartHeader;
